// @ts-nocheck
import React, { Fragment, useState, useEffect, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react'
import { Link } from 'react-router-dom';
import { Toaster, toast } from 'sonner';
import { UserDetails } from '../../auth/authTypes';
import { useAppDispatch } from '../../../app/hooks';
import { deleteTeams, fetchBoardsList } from '../../teams/teamsSlice';
import Badge from '../../../components/common/Badge';
import DropDown from '../../../components/common/DropDown';
import { createDepartment, fetchDepartmentList, fetchLocationListStatus, updateLocation } from '../../department/departmentSlice';
import { getColorForLabel } from '../../../utils/colorUtils';
import { createTeamsPayload } from '../../department/departmentTypes';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ChevronDownIconWhite, CrossIcon, CustomCheckIcon, ExclamationIcon, ThreeDotIcon } from '../../../components/icons/Icons';
import CreateDepartment from './CreateDepartment';
import CreateEditDepartment from './CreateEditDepartment';

type ChannelProps = {
  userDetails: UserDetails | null;
}

function classNames(...classes: any) {
  return classes.filter(Boolean).join(' ')
}

const roleSearchList = [
  { name: "active" }, 
  // { name: "deleted" },
 { name: "archived" }
]

const Departments: React.FC<ChannelProps> = React.memo(({ }) => {
  const baseIdString = localStorage.getItem('UserBaseId') || localStorage.getItem('createBaseId');
  const baseId = baseIdString ? JSON.parse(baseIdString) : null;
  const navigate = useNavigate()
  const [searchVal, setSearchVal] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editBoardData, setEditBoardData] = useState<{ id: number; baseId: number } | null>(null);
  const [boardsFetched, setBoardsFetched] = useState<any[]>([]);
  const dispatch = useAppDispatch();
  const [dataLoading, setDataLoading] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [selectSearchRole, setSelectSearchRole] = useState("active")
  const [loading, setLoading] = useState(false)
  const [loading1, setLoading1] = useState(false)
  const [departmentCreate, setDepartmentCreate] = useState(false)
  const [baseLoading, setBaseLoading] = useState(false)
  const [description, setDescription] = useState('')
  const [name, setName] = useState('');
  const [data, setData] = useState<any>();
  const [nameError, setNameError] = useState('');
  const [color, setColor] = useState('bg-[#3b82f6]');


  const colorList = [
    { name: "bg-[#3b82f6]" },
    { name: "bg-[#6b7280]" },
    { name: "bg-[#bfdbfe]" },
    { name: "bg-[#ec4899]" },
    { name: "bg-[#6366f1]" },
    { name: "bg-[#eab308]" },
    { name: "bg-[#22c55e]" },
    { name: "bg-[#06b6d4]" },
    { name: "bg-[#dc2626]" },
  ];



  // In Teams component
  useEffect(() => {
    const teamInfoString = localStorage.getItem('baseDepartmentData');
    if (teamInfoString) {
      const teamInfo = JSON.parse(teamInfoString);
      setBoardsFetched(teamInfo.data);
      setDataLoading(false);
    } else {
      const fetchTeams = async () => {
        setDataLoading(true);
        try {
          const baseResponse = await dispatch(fetchDepartmentList(baseId));

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem('baseDepartmentData', JSON.stringify(baseResponse.payload));
          } else {
            setBoardsFetched([]);
          }
        } catch (error) {
          console.error("Error fetching teams:", error);
          setBoardsFetched([]);
        } finally {
          setDataLoading(false);
        }
      };

      if (baseId) {
        fetchTeams();
      }
    }
  }, [baseId, dispatch]);



  // Add a new useEffect to handle updates from localStorage
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'baseDepartmentData' && e.newValue) {
        const teamsDataArray = JSON.parse(e.newValue);
        setBoardsFetched(teamsDataArray.data || []);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);


  const handleDeleteBoard = useCallback(async (id: number, baseId: number) => {
    const payload: createTeamsPayload = {
      status: 'deleted',
      id: id
    };

    try {
      // Update existing team
      const response = await dispatch(updateLocation({
        payload,
        userId: baseId,
        departmentId: id
      }));

      if (response?.payload) {
        
        //  toast.success('Status has been updated successfully');
        toast.success('Department deleted successfully');
        // Update the local storage and state
        // const updatedBoards = boardsFetched.map(board =>
        //   board.id === id ? { ...board, status: 'deleted' } : board
        // );
        const updatedBoards = boardsFetched.filter(board => board.id !== id);

        localStorage.setItem('baseDepartmentData', JSON.stringify({ data: updatedBoards }));

        setBoardsFetched(updatedBoards);

        setIsModalOpen(false);
        setEditBoardData(null);
      } else {
        toast.error('Failed to update status');
      }
    } catch (error) {
      toast.error('An error occurred while updating the status');
      console.error(error);
    }
  }, [boardsFetched, dispatch]);

  const handleArchivedBoard = useCallback(async (id: number, baseId: number, changeStatus: string) => {
    const payload: createTeamsPayload = {
      status: changeStatus,
      id: id
    };

    try {
      // Update existing team
      const response = await dispatch(updateLocation({
        payload,
        userId: baseId,
        departmentId: id
      }));

      if (response?.payload) {
        toast.success('Status has been updated successfully');
        // Update the local storage and state
        // const updatedBoards = boardsFetched.map(board =>
        //   board.id === id ? { ...board, status: 'archived' } : board
        // );
        const updatedBoards = boardsFetched.filter(board => board.id !== id);

        localStorage.setItem('baseDepartmentData', JSON.stringify({ data: updatedBoards }));

        setBoardsFetched(updatedBoards);

        setIsModalOpen(false);
        setEditBoardData(null);
      } else {
        toast.error('Failed to update status');
      }
    } catch (error) {
      toast.error('An error occurred while updating the status');
      console.error(error);
    }
  }, [boardsFetched, dispatch]);




  const handleEdit = useCallback((id: number, baseId: number) => {
    const teamToEdit = boardsFetched.find(team => team.id === id);

    if (teamToEdit) {
      setEditBoardData(teamToEdit);
      setIsModalOpen(true);
    }
  }, [boardsFetched]);


  // const handleTeamsData = (id) => {
  //   navigate(`/${baseId}/settings/department/${id}/view`);
  // }

  const handleSearchRoleChange = (role: string) => {
    setSelectSearchRole(role)
  }

  const handleCreateDepartment = () => {
    navigate(`/${baseId}/settings/department/create`);
  };

  const handleActive = async () => {
    setLoading1(true);
    try {
      const res = await dispatch(fetchLocationListStatus({ baseId, status: 'active' }));
      if (res.payload) {
        setBoardsFetched(res.payload.data);
        localStorage.setItem('baseDepartmentData', JSON.stringify(res.payload));
      } else {
        console.error('No payload received');
      }
    } catch (error) {
      console.error('Delete failed:', error);
      // alert('Failed to delete location data. Please try again later.');
    } finally {
      setLoading1(false);
    }
  };


  const handleDelete = async () => {
    setLoading1(true);
    try {
      const res = await dispatch(fetchLocationListStatus({ baseId, status: 'deleted' }));
      if (res.payload) {
        setBoardsFetched(res.payload.data);
        localStorage.setItem('baseDepartmentData', JSON.stringify(res.payload));
      } else {
        console.error('No payload received');
      }
    } catch (error) {
      console.error('Delete failed:', error);
      // alert('Failed to delete location data. Please try again later.');
    } finally {
      setLoading1(false);
    }
  };


  const handleSuspend = async () => {
    setLoading(true)
    try {
      const res = await dispatch(fetchLocationListStatus({ baseId, status: 'archived' }));
      if (res.payload) {
        setBoardsFetched(res.payload.data)
        // Update local storage
        localStorage.setItem('baseDepartmentData', JSON.stringify(res.payload));
      } else {
        console.error('No payload received');
      }
    } catch (error) {
      console.error('Suspend failed:', error);
    } finally {
      setLoading(false)
    }
  };




  const handleAddDepartment = () => {
    setDepartmentCreate(true)
  }

  const _updateHandler = async () => {
    // Validate the department name
    if (!name.trim()) {
      setNameError('Department name is required.');
      return;
    }

    // Clear any existing errors if validation passes
    setNameError('');
    setBaseLoading(true);
    const colorValue = color.substring(color.indexOf("[#") + 1, color.indexOf("]"));

    const payload: UpdateBasePayload = {
      department_name: name,
      department_description: description,
      department_color: colorValue,
      // id: data?.id
    };

    const userId = baseId;
    try {
      // Dispatch the createDepartment action with payload and userId
      const resultAction = await dispatch(createDepartment({ payload, userId }));
      setBaseLoading(false);

      // Check if the action was successful
      if (createDepartment.fulfilled.match(resultAction)) {
        // Store the new department data in local storage
        localStorage.setItem('baseCreateDepartmentData', JSON.stringify(resultAction.payload));
        setData(resultAction.payload);
        toast.success('Create department successfully!');

        // Fetch updated department list
        const baseResponse = await dispatch(fetchDepartmentList(baseId));
        if (fetchDepartmentList.fulfilled.match(baseResponse)) {
          // Store the fetched department list in local storage
          const updatedDepartments = baseResponse.payload;
          localStorage.setItem('baseDepartmentData', JSON.stringify(updatedDepartments));
          setBoardsFetched(updatedDepartments.data); // Directly update the state
        }

        // Clear form fields
        setName('');
        setDescription('');
        setColor('bg-[#3b82f6]')
        setDepartmentCreate(false);
        // navigate(`/${baseId}/settings/department/${resultAction?.payload?.data?.id}/edit`);
      } else {
        // Handle errors if the action failed
        const errorMessage = resultAction.payload as string || 'Failed to create department';
        toast.error(errorMessage?.replace(/_/g, " "));
      }
    } catch (error) {
      // Catch any unexpected errors during the API call
      console.error('Error:', error);
      toast.error('An unexpected error occurred. Please try again later.');
      setBaseLoading(false);
    }
  };



  return (
    <>
      <Toaster richColors />
      <div className='h-full'>
        <main className='py-[34px] lg:py-[70px] px-0 lg:px-10 h-full flex'>
          <div className='px-[2px] sm:px-6 lg:px-8 w-full flex justify-center'>
            <div className='w-full max-w-[640px]'>
              <div className='flex flex-col gap-y-1 w-full'>
                <h2 className='text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]'>
                  Base Departments
                </h2>
                <p className='text-sm leading-5 text-[#5c5c5e] font-medium'>
                  Add and manage your company's departments. You can then assign jobs to a specific department to keep your hiring organized.
                </p>
              </div>

              <div className='bg-[#e0e0e0] w-full h-[1px] my-8'></div>

              <div className=' mt-0 lg:mt-0 flex items-center  w-full gap-x-3'>

                <div className='w-full lg:w-[40%]'>

                  <div className=''>
                    <input
                      type="text"
                      value={searchVal}
                      onChange={(e) => setSearchVal(e.target.value)}
                      name="search"
                      id="search"
                      placeholder='Search name'
                      className="flex w-full grow border px-4 pt-2 pb-[10px] text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                      focus:outline focus:outline-2 focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                           border-[#e7e7e8] dark:border-surface-100 focus:outline-indigo-600 h-[34px] rounded-[0.375rem]"
                    />
                  </div>
                </div>

                <div className='w-full lg:w-[20%]'>
                  <div className=''>
                    <DropDown
                      onChangeValue={handleSearchRoleChange}
                      data={roleSearchList}
                      previousValue={selectSearchRole}
                      onDelete={handleDelete}
                      onArchived={handleSuspend}
                      onActive={handleActive}
                    />
                    {/* <DropDown onChangeValue={(value) => setSelectSearchRole(value)} data={roleSearchList} previousValue={selectSearchRole} /> */}

                  </div>
                </div>
                <div className='w-full lg:w-[40%]'>
                  <div className='my-0 flex justify-end'>
                    <button
                      // onClick={handleCreateDepartment}
                      onClick={handleAddDepartment}
                      type='button'
                      className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Create Department
                    </button>
                  </div>
                </div>

              </div>


              <div className='mt-6 lg:mt-6 pb-10'>
                <div className="bg-white rounded-lg border border-solid border-[#0009321f]">
                  <div className="font-semibold text-[#1c2024] text-sm  px-[11.4px] py-[11.4px] bg-[#00005506] border-b border-solid border-[#0009321f]">Name</div>
                  {dataLoading ? (
                    <div className="flex items-center justify-center relative z-50" style={{ height: 'calc(100vh - 391px)' }}>
                      <div className="simple-spinner-loader">
                        <span></span>
                      </div>
                    </div>
                  ) : boardsFetched.length === 0 ? (
                    <div className='w-full mt-5 flex h-[100px] justify-center items-center flex-col gap-y-3'>
                      <ExclamationIcon />
                      <p className='text-[#0000007a] text-[13px]'>No results found</p>
                    </div>
                  ) : (
                    <>
                      {boardsFetched
                        .filter((post: { department_name: String }) => {
                          if (searchVal === "") {
                            return post;
                          } else if (post?.department_name.toLowerCase().includes(searchVal.toLowerCase())) {
                            return post;
                          }
                        })
                        .map((items: any, index: number) => {
                          const bgColor = getColorForLabel(items?.department_name);
                          return (
                            <div key={index} className='w-full flex border-b border-light-gray-200 last-of-type:border-none'>
                              <ul className='list-none w-full'>
                                <li className='flex flex-row items-center justify-between text-[0.875rem] px-[11.4px] py-[11.4px] w-full'>
                                  <div className='flex shrink-0 pr-2'>
                                    {
                                      items?.department_image ? (
                                        <img
                                          src={`${process.env.REACT_APP_API_BASE_URL}/${items?.department_image}`}
                                          alt="Profile"
                                          className="h-[35px] w-[35px] rounded-[6px] flex flex-row items-center justify-center text-white"
                                        />
                                      ) : (
                                        <div
                                          className="h-[35px] w-[35px] rounded-[6px] flex flex-row items-center justify-center text-white"
                                          style={{ backgroundColor: items.department_color || '#d7d7d7' }}
                                        >
                                          <p>{items?.department_name?.charAt(0).toUpperCase()}</p>
                                        </div>
                                      )
                                    }

                                  </div>
                                  <div className='flex-1 px-2'
                                  // onClick={() => handleTeamsData(items?.id)}
                                  >
                                    <p className='text-[0.8125rem] font-semibold leading-5 text-[#1b1b1b] capitalize'>{items?.department_name}</p>
                                    <p className='flex text-xs text-[12px] leading-4 text-[#5c5c5e] line-clamp-1'>{items?.department_description}</p>
                                  </div>
                                  <div>
                                    <Badge status={items?.status} />
                                  </div>
                                  <div className='px-2 flex items-center'>
                                    <Menu as="div" className="relative inline-block text-left">
                                      <div>
                                        <MenuButton className="rounded-md flex items-center justify-center hover:bg-light-gray-200 focus:bg-light-gray-200 w-[32px] h-[32px]">
                                          <span className="sr-only">Open options</span>
                                          <ThreeDotIcon />
                                        </MenuButton>
                                      </div>

                                      <Transition
                                        enter="transition ease-out duration-100"
                                        enterFrom="transform opacity-0 scale-95"
                                        enterTo="transform opacity-100 scale-100"
                                        leave="transition ease-in duration-75"
                                        leaveFrom="transform opacity-100 scale-100"
                                        leaveTo="transform opacity-0 scale-95"
                                      >
                                        <MenuItems
                                          className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[108px] min-w-[108px] w-full overflow-hidden rounded-lg border border-border
                                      bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                                      data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2
                                       data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
                                        >
                                          <div className="py-1">
                                            <MenuItem>
                                              {({ focus }) => (
                                                <div
                                                  onClick={() => handleEdit(items.id, items.base_id)}
                                                  className={classNames(
                                                    focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                                    "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0"
                                                  )}
                                                >
                                                  Edit
                                                </div>
                                              )}
                                            </MenuItem>
                                            <MenuItem>
                                              {({ focus }) => (
                                                <Link
                                                  to="#"
                                                  className={classNames(
                                                    focus ? "bg-gray-100 text-gray-900" : "text-gray-700",
                                                    "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0"
                                                  )}
                                                  onClick={() => handleDeleteBoard(items.id, items.base_id)}
                                                >
                                                  Delete
                                                </Link>
                                              )}
                                            </MenuItem>
                                             {selectSearchRole === "active" &&  <MenuItem>
                                                                                          {({ focus }) => (
                                                                                            <Link
                                                                                              to="#"
                                                                                              onClick={() =>
                                                                                                handleArchivedBoard(
                                                                                                  items.id,
                                                                                                  items.base_id,
                                                                                                  'archived'
                                                                                                )
                                                                                              }
                                                                                              className={classNames(
                                                                                                focus
                                                                                                  ? "bg-gray-100 text-gray-900"
                                                                                                  : "text-gray-700",
                                                                                                "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                                                                              )}
                                                                                            >
                                                                                              Archived
                                                                                            </Link>
                                                                                          )}
                                                                                        </MenuItem>}
                                                                                         {selectSearchRole === "archived" && <MenuItem>
                                                                                          {({ focus }) => (
                                                                                            <Link
                                                                                              to="#"
                                                                                              onClick={() =>
                                                                                                handleArchivedBoard(
                                                                                                  items.id,
                                                                                                  items.base_id,
                                                                                                  'active'
                                                                                                )
                                                                                              }
                                                                                              className={classNames(
                                                                                                focus
                                                                                                  ? "bg-gray-100 text-gray-900"
                                                                                                  : "text-gray-700",
                                                                                                "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                                                                              )}
                                                                                            >
                                                                                              Active
                                                                                            </Link>
                                                                                          )}
                                                                                        </MenuItem>
                                                                    }

                                          </div>
                                        </MenuItems>
                                      </Transition>
                                    </Menu>
                                  </div>
                                </li>
                              </ul>
                            </div>
                          );
                        })}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>

      <Dialog open={departmentCreate} onClose={setDepartmentCreate} className="relative z-10">
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                <button
                  type="button"
                  onClick={() => setDepartmentCreate(false)}
                  className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                >
                  <span className="sr-only">Close</span>
                  <CrossIcon />
                </button>
              </div>
              <div className="flex flex-col gay-y-4">
                <DialogTitle
                  as="h3"
                  className="text-base font-semibold leading-6 text-gray-900"
                >
                  Add Department
                </DialogTitle>

                <div className='w-full mt-5'>
                  <label htmlFor='username' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5'>
                    Name
                  </label>

                  <div className="relative">
                    <Menu as='div' className='flex items-center'>
                      <Menu.Button className='absolute inset-y-0 left-0 flex items-center px-2'>
                        <div className={`h-6 w-6 rounded-full ${color} border flex justify-center items-center`}>
                          <ChevronDownIconWhite />
                        </div>
                      </Menu.Button>
                      <Transition
                        as={Fragment}
                        enter='transition ease-out duration-100'
                        enterFrom='transform opacity-0 scale-95'
                        enterTo='transform opacity-100 scale-100'
                        leave='transition ease-in duration-75'
                        leaveFrom='transform opacity-100 scale-100'
                        leaveTo='transform opacity-0 scale-95'>
                        <Menu.Items className='absolute flex flex-wrap left-0 top-8 z-10 mt-2.5 w-44 p-2 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none'>
                          {colorList.map((value, index) => (
                            <div
                              onClick={() => setColor(value.name)}
                              key={index}
                              className={`flex h-6 w-6 border ${value.name} rounded-full m-2 justify-center items-center cursor-pointer`}
                            >
                              {color === value.name && <CustomCheckIcon />}
                            </div>
                          ))}
                        </Menu.Items>
                      </Transition>
                      <input
                        id='name'
                        name='name'
                        type='name'
                        autoComplete='name'
                        onChange={(e) => {
                          setName(e.target.value)
                        }}
                        placeholder='Enter Name'
                        value={name}

                        className="flex w-full grow border pl-10 pr-4 py-2 text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)]
               transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600 focus:outline focus:outline-2 
               focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200 border-[#d1d1db]
                dark:border-surface-100 focus:outline-indigo-600 h-[36px] rounded-[0.375rem]"                      />
                    </Menu>
                  </div>


                  {nameError && (
                    <p className="text-red-500 text-sm mt-1">{nameError}</p>
                  )}

                </div>
                <div className='w-full mt-4'>
                  <label htmlFor='description' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased  leading-5'>
                    Description
                  </label>
                  <div className='mt-[6px]'>
                    <textarea
                      id='description'
                      name='description'
                      type='description'
                      rows={3}
                      maxLength={1500}
                      autoComplete='description'
                      onChange={(e) => {
                        setDescription(e.target.value)
                      }}
                      placeholder='Enter Description'
                      value={description}
                      className="flex grow rounded-md border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500
				               outline-primary focus:outline focus:outline-2 focus:-outline-offset-1 w-full
				                text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600"
                    />
                  </div>

                </div>
              </div>
              <div className="flex gap-x-4 items-center justify-end mt-5">
                <button
                  onClick={_updateHandler}
                  type='submit'
                  className='group inline-flex shrink-0 w-full select-none items-center justify-center leading-6 transition-colors
                duration-100 wg-antialiased focus:outline-0 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 disabled:pointer-events-none gap-0 
                 rounded-md  px-[14px] py-1 text-[13px] font-medium h-[32px] text-white outline-indigo-600
                disabled:opacity-50 bg-indigo-600 hover:bg-indigo-500 focus-visible:outline-indigo-600'                size="sm"
                >

                  {baseLoading ? (
                    <div className='flex items-center  gap-[6px]'>
                      Save
                      <div className="simple-spinner">
                        <span></span>
                      </div>
                    </div>
                  ) : (
                    'Save'
                  )}
                </button>

              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>

      <CreateEditDepartment
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        editBoardData={editBoardData}
        baseId={baseId}
        setEditBoardData={setEditBoardData}
      />
    </>
  )
});
export default Departments
